// components/connection-helpers.js: Batch D player-row connection labels.
//
// The server reports connected/lagging/disconnected (see
// server/src/room/room.js). Players read connected/reconnecting/away:
// "lagging" is server jargon, "reconnecting" says what is happening, and
// "away" says what it means for the table. Every state pairs its text
// with its own colour so the cue works with and without colour vision.

/** @typedef {'connected'|'lagging'|'disconnected'} ServerConnectionStatus */

const BY_STATUS = Object.freeze({
  connected:    Object.freeze({ label: 'connected',    color: '#3DBA52' }),
  lagging:      Object.freeze({ label: 'reconnecting', color: '#F0A030' }),
  disconnected: Object.freeze({ label: 'away',         color: '#E03048' }),
});

const FALLBACK = BY_STATUS.connected;

/**
 * @param {unknown} status  the server's connection_status value
 * @returns {{ label: string, color: string }}
 */
export function describeConnection(status) {
  if (status && typeof status === 'string') {
    const known = BY_STATUS[/** @type {keyof typeof BY_STATUS} */ (status)];
    if (known) return known;
  }
  return FALLBACK;
}
